import logo from "../../Images/logo.svg";
import "./navbar.css";
import { Link } from "react-router-dom";
export default function Navbar() {

   const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  function scrollToSection(sectionId) {
    setTimeout(() => {
      const section = document.getElementById(sectionId);
      if (section) {
        const yOffset = -200;
        const yPosition = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: yPosition, behavior: 'smooth' });
      }
    }, 200)
  }


  return (
    <div className="Navbar">
      <nav className="navbar navbar-expand-lg shadow-sm fixed-top ">
        <div className="container-fluid">
          <div>
             <Link to={{pathname:"/"}} className=".navbar-brand" onClick={scrollToTop}>
              <img src={logo} />
              </Link>
           
          </div>
          <div>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div
              className=" collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav me-auto">
                <li className="nav-item">
                  <Link to="/" className="nav-link p-3 ms-3" onClick={() => scrollToSection('section3')}>Get To Know Us</Link>
                </li>

                <li className="nav-item">
                   <Link to="/" className="nav-link p-3 ms-3" onClick={() => scrollToSection('section9')}> Lending Services</Link>
                 
                </li>
                <li className="nav-item">
                  <Link to="/" className="nav-link p-3 ms-3" onClick={() => scrollToSection('section11-bottom')}> CNMP Advantages</Link>
                 
                </li>
                <li className="nav-item">
                   <Link to="/" className="nav-link p-3 ms-3" onClick={() => scrollToSection('footer')}> Contact Us</Link>
                 
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}
